export default __webpack_public_path__ + "static/media/Legguards of the Beyond.f4e3930b.jpg";